import 'react-app-polyfill/ie11';
import 'react-app-polyfill/stable';
import JSZip from 'jszip';
import ReactDOM from 'react-dom';
import { hot } from 'react-hot-loader/root';
import App from './views/layout/App';

import "rc-slider/assets/index.css";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import '@toast-ui/editor/dist/toastui-editor.css';

import "@Scss/Common.scss";
import "@Scss/Header.scss";
import "@Scss/Footer.scss";
import "@Scss/Body.scss";
import "@Scss/Media.scss";
import "@Scss/Grid.scss";
import "@Scss/new.scss";

const Hot = hot(App);
const win:any = window;
win.JSZip = JSZip;

ReactDOM.render(
  <Hot />,
  document.getElementById('root')
);
